// extracted by mini-css-extract-plugin
module.exports = {"dialogLine":"DialogLine_dialogLine_3Ly-i"};